export const leagueSvg = (props = {}) => {
  return (
    <svg
      {...props}
      width={props.width || "40"}
      height={props.height || "20"}
      viewBox="0 0 22 30"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title />
      <g data-name="Layer 2" id="Layer_2">
        <g id="Interface-Light">
          <g
            id="interface-light-award-medal-1"
            fill="none"
            stroke={props.fill || "#ffff"}
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <polyline points="21.5 0.5 10.5 0.5 0.5 0.5" />
            <line x1="21.5" x2="17" y1="0.5" y2="12.5" />
            <line x1="0.5" x2="5" y1="0.5" y2="12.5" />
            <circle cx="11" cy="20" r="9.5" />
            <line x1="8" x2="9" y1="0.5" y2="10.5" />
            <line x1="14" x2="13" y1="0.5" y2="10.5" />
            <path d="M11.49,15.35l.91,2.59a.52.52,0,0,0,.46.36l2.64.11a.54.54,0,0,1,.3,1l-2.07,1.71a.58.58,0,0,0-.18.57l.72,2.66a.53.53,0,0,1-.79.6l-2.19-1.54a.51.51,0,0,0-.58,0L8.52,24.91a.53.53,0,0,1-.79-.6l.72-2.66a.58.58,0,0,0-.18-.57L6.2,19.37a.54.54,0,0,1,.3-1l2.64-.11a.52.52,0,0,0,.46-.36l.91-2.59A.52.52,0,0,1,11.49,15.35Z" />
          </g>
        </g>
      </g>
    </svg>
  );
};
